import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  const {
    ref
  } = useRevealOnScroll();
  return <section ref={ref} className="relative w-full aspect-[3/1] min-h-[420px] light flex items-center justify-center overflow-hidden" style={{
    backgroundColor: "#ffffff",
    backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/66b934bd-4534-426f-8645-e441de73be84.png)",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "rgb(26, 46, 32)",
    fontFamily: "Inter, sans-serif"
  }}>

      
    </section>;
}